import React from 'react'

import '../styles/footer.css';

const Footer = () => {

    const Year = new Date().getFullYear();

    return (
        <div className="footer">
            <div className="social-container">
                
            </div>

            <p>Copyright Hudzaifah &copy; {Year}</p>
        </div>
    )
}

export default Footer
